module.exports = __webpack_public_path__ + "static/media/cat.1a4683d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/cat.png
// module id = 19
// module chunks = 0